const TextIndicator = ({ isText }) => {
  const basePath = `${window.location.origin}/images`;

  return (
    <img
      src={
        isText
          ? `${basePath}/text-selected.png`
          : `${basePath}/text-not-selected.png`
      }
      alt="Text Indicator"
      style={{ width: 18, height: 18 }}
    />
  );
};

export default TextIndicator;
